import React, { Component } from "react";
import { getUnfinishedMatch } from "../../services/matchService";
import { saveMatchBet } from "./../../services/matchBetService";
import auth from "../../services/authService";
import Team from "../team";
import Counter from "../counter";

class MatchBetForm extends Component {
  state = {
    id: -1,
    league: "",
    season: "",
    matchDay: "",
    match: -1,
    dateTime: new Date(),
    teamHome: new Team(),
    teamAway: new Team(),
    scoreHome: 0,
    scoreAway: 0
  };

  async componentDidMount() {
    await this.getUnfinishedMatch();
  }

  initState = (
    league,
    season,
    matchDay,
    match,
    dateTime,
    teamHome,
    teamAway
  ) => {
    this.setState({
      id: -1,
      league: league,
      season: season,
      matchDay: matchDay,
      match: match,
      dateTime: dateTime,
      teamHome: teamHome,
      teamAway: teamAway,
      scoreHome: 0,
      scoreAway: 0
    });
  };

  getUnfinishedMatch = async () => {
    this.initState("", "", "", -1, new Date(), new Team(), new Team());
    const matches = await getUnfinishedMatch(auth.getCurrentUser().id, 1);

    if (matches && matches.length > 0)
      this.initState(
        matches[0].league.name,
        matches[0].season.name,
        matches[0].matchDay.name,
        matches[0].id,
        new Date(matches[0].dateTime),
        matches[0].teamHome,
        matches[0].teamAway
      );
  };

  handleValueChange = (isHome, value) => {
    let score = isHome ? this.state.scoreHome : this.state.scoreAway;
    score += value;
    if (isHome) this.setState({ scoreHome: score });
    else this.setState({ scoreAway: score });
  };

  handleSave = async event => {
    event.currentTarget.className = "hidden";

    const { match, scoreHome, scoreAway } = this.state;

    const saveBet = {
      id: -1,
      user: auth.getCurrentUser().id,
      match: match,
      scoreHome: scoreHome,
      scoreAway: scoreAway
    };

    await saveMatchBet(saveBet);
    await this.getUnfinishedMatch();
  };

  formatDate = () => {
    return this.state.dateTime.toLocaleDateString();
  };

  formatTime = () => {
    const { dateTime } = this.state;
    return dateTime.getHours() + ":" + ("0" + dateTime.getMinutes()).slice(-2);
  };

  render() {
    const {
      league,
      season,
      matchDay,
      teamHome,
      teamAway,
      scoreHome,
      scoreAway,
      dateTime
    } = this.state;

    return (
      <div className="center m-2">
        {league || <span className="league"><br></br>No matches to bet on. Come back later.</span>}
        {/* <ToastContainer /> */}
        {!league || (
          <table className="center">
            <tbody>
              <tr>
                <td colSpan="2" className="league">
                  {league + " " + season}
                </td>
              </tr>
              <tr>
                <td colSpan="2" className="match-day">
                  {matchDay}
                </td>
              </tr>
              <tr>
                <td colSpan="2" className="date">
                  {this.formatDate()}
                  <br />
                  {this.formatTime()}
                </td>
              </tr>
              <tr>
                <td className="match-teams">
                  {" "}
                  <Team name={teamHome.name} logo={teamHome.logo} />
                  <Counter
                    onIncrement={() => this.handleValueChange(true, 1)}
                    onDecrement={() => this.handleValueChange(true, -1)}
                    allowEdit={dateTime > new Date()}
                    value={scoreHome}
                  />{" "}
                </td>
                <td className="match-teams">
                  {" "}
                  <Team name={teamAway.name} logo={teamAway.logo} />
                  <Counter
                    onIncrement={() => this.handleValueChange(false, 1)}
                    onDecrement={() => this.handleValueChange(false, -1)}
                    allowEdit={dateTime > new Date()}
                    value={scoreAway}
                  />
                </td>
              </tr>
              <tr>
                <td colSpan="2">
                  <br />
                  <button
                    onClick={this.handleSave}
                    className={
                      dateTime > new Date() ? "btn btn-warning m-2" : " hidden"
                    }
                  >
                    <i className="fa fa-save fa-2x" />
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
        )}
      </div>
    );
  }
}

export default MatchBetForm;



// WEBPACK FOOTER //
// ./src/components/matchBets/matchBetForm.jsx